module.exports = __webpack_public_path__ + "img/icon-telegram-graph.784c8f04.svg";